/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:100%;height:100%}.gallery-container[_ngcontent-%COMP%]{height:100%;width:100%;display:grid;display:grid;grid-template-areas:'filters controls' 'body body';grid-template-columns:1fr auto;grid-template-rows:auto 1fr}.gallery-container__filters[_ngcontent-%COMP%]{grid-area:filters;padding:8px 8px 8px 0}.gallery-container__controls[_ngcontent-%COMP%]{grid-area:controls;padding:8px 0}.gallery-container__body[_ngcontent-%COMP%]{grid-area:body;padding:8px 0;overflow-y:hidden}"];
export { styles as styles };
